<template>
    <div class="real-name-box">
        <tab name="1"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                    <el-input placeholder="请输入内容" v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryKey" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="证件号" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :sm="12" :md="8" :lg="8" :xl="4" >
                    <el-button v-if="$utils.have('/commonPerformer/search')" type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>					
                </el-col>
            </el-row>
        </div>
		<!-- <div class="page-btns-box">
			<el-button v-if="$utils.have('/commonPerformer/resetFaceNum')" type="primary" @click="$refs.resetFaceNum.show()" size="small">重置人脸验证次数</el-button>
			<el-button v-if="$utils.have('/commonPerformer/skipFaceAuth')" type="primary" @click="$refs.skipFaceAuth.show()" size="small">跳过人脸验证</el-button>
		</div> -->
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="账号状态">
                    <template slot-scope="scope">
                        {{scope.row.status != undefined && accountStatus.get(scope.row.status)}}
                    </template>
                </el-table-column>
                <el-table-column label="身份">
                    <template slot-scope="scope">
                        {{scope.row.userType && $userType.get(scope.row.userType)}}
                    </template>
                </el-table-column>
                 <el-table-column label="认证情况" min-width="150px">
                    <template slot-scope="scope">
                        <div>
                            证件认证：
                            <span v-if="scope.row.passIDAuth" class="color-success">已通过</span>
                            <span v-else class="color-danger">未通过</span>
                        </div>
                        <div>
                            人脸认证：
                            <span v-if="scope.row.passFaceAuth" class="color-success">已通过</span>
                            <span v-else class="color-danger">未通过</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="用户ID" prop="userId"></el-table-column>
                <el-table-column label="用户名称" prop="userName" show-overflow-tooltip min-width="100"></el-table-column>
                <el-table-column label="姓名" prop="name"></el-table-column>
                <el-table-column label="当前生效证件" min-width="160px">
                    <template slot-scope="scope">
                        <div>{{scope.row.documentType}}</div>
                        <el-link 
                            type="text" 
                            size="small" 
                            v-if="$utils.have('/commonPerformer/getIdCard') && scope.row.id && scope.row.documentType == '身份证'" 
                            style="font-size:12px" 
                            @click="infoVisible=true; infoId=scope.row.id">
                                {{scope.row.documentNumber	}}
                        </el-link>
                        <template v-else>{{scope.row.documentNumber	}}</template>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="台胞证" prop="twNum" min-width="150px"></el-table-column>
                <el-table-column label="护照" prop="passPortNum" min-width="150px"></el-table-column>
                <el-table-column label="港澳通行证" prop="hongKongMacauNum" min-width="150px"></el-table-column> -->
                <el-table-column label="支付订单数" prop="payOrderNum"></el-table-column>
                <el-table-column label="注册时间" prop="registTime" min-width="150px"></el-table-column>
                <el-table-column label="最近登录时间" prop="loginTime" min-width="150px"></el-table-column>
                <el-table-column fixed="right" label="操作" width="450" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            v-if="$utils.have('/commonPerformer/updatePerformer')"
                            @click="realNameVisible = true; editData=scope.row;"
                            >证件认证</el-button>
                        <el-button
                            type="text"
                            size="small"
                            v-if="$utils.have('/commonPerformer/passFaceAuth') && !scope.row.passFaceAuth"
                            @click="passFaceAuth(scope.row.userId)"
                            >通过账号实人认证</el-button>
						<el-button
						    type="text"
						    size="small"
						    v-if="scope.row.documentType == '身份证' && scope.row.documentNumber"
						    @click="goFace(scope.row.documentNumber)"
						    >人脸验证管理</el-button>
						<el-button
						    type="text"
						    size="small"						   
						    @click="goFans(scope.row.userId)"
						    >乐迷详情</el-button>
						<el-button
						    type="text"
						    size="small"
							v-if="$utils.have('/commonPerformer/auth_clear')"
						    @click="clean(scope.row.userId)"
						    >清除实名信息</el-button>
							
                        <!--<el-button
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="toOrderList(scope.row.id)"
                            >查看订单</el-button> /user/fans/edit/18799198 -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Edit :realNameVisible.sync="realNameVisible" :editData="editData"/>
        <Info :infoVisible.sync="infoVisible" :infoId="infoId"/>
        <!-- <SkipFaceAuth ref="skipFaceAuth"></SkipFaceAuth>
		<ResetFaceNum ref="resetFaceNum"></ResetFaceNum> -->
    </div>
</template>
<script>
import Edit from './components/edit';
import Info from './components/info';
// import SkipFaceAuth from './components/skipFaceAuth';
// import ResetFaceNum from './components/resetFaceNum';
import Tab from './components/tab';
const defaultData = {
    queryKey: 1,
    queryValue: '' 
}
export default {
    data() {
        return {
            dataList: null,
            params: {...defaultData},
            listLoading: false,
            realNameVisible: false,
            editData: null,
            infoVisible: false,
            infoId: null
        };
    },
    components: {
        Edit,
        Info,
        // SkipFaceAuth,
		// ResetFaceNum,
        Tab
    },
    computed: {
        accountStatus(){
            return new Map([
                [1, '正常'],
                [0, '注销']
            ])
        }
    },
    created(){
        const id = this.$route.query.id;
        if(id){
            this.params.queryValue = id;
            this.getDataList()
        }
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            if(this.params.queryValue == ''){
                this.listLoading = false;
                this.dataList = [];
                return
            }
            this.$request({
                url: "/commonPerformer/search",
                method: "POST",
                params: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        const data = result || [];
                        // const arr = ['idNum', 'passPortNum', 'twNum', 'hongKongMacauNum'];                        
                        // data.forEach(i=> {
                        //     for(let j of arr){
                        //         i[j] = i[j] || '无';
                        //     }
                        // })
                        this.dataList = data;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                    
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {...defaultData}
            const id = this.$route.query.id;
            if(id) this.params.queryValue = id;
            this.getDataList();
        },
        // 跳转乐迷详情
        goFans(id){
            this.$router.push({
                path: `/user/fans/edit/${id}`,
            });
        },
		goFace(documentNumber){			
			this.$router.push({
			    path: `/user/realName/faceManage`,
			    query: {
			        documentNumber: documentNumber
			    },
			});
		},
		clean(id){			
			this.$confirm("清除实名信息会让人脸认证也一并失效，是否清除?", '清除实名信息', {
			    type: 'warning',
			    center: false,
			    closeOnClickModal: false
			}).then(() => {
			    this.$request({			        
					url: "/commonPerformer/auth_clear",
			        method: "POST",
			        params: {userId: id},
			    })
			        .then((res) => {
			            const { state, msg } = res.data;
			            if (state && state == 1 ) {
			                this.$message.success("操作成功");
			                this.getDataList();
			            } else {
			                this.$message.error(msg || "请求失败");
			            }
			        })
			})
		},
        //通过人脸认证
        passFaceAuth(userId){
            this.$confirm("请确认已经核验账号主用户真实身份，再操作通过账号实人认证", '通过账号实人验证', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.$request({
                    url: "/commonPerformer/passFaceAuth",
                    method: "POST",
                    params: {userId: userId},
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state && state == 1 ) {
                            this.$message.success("账号实人验证已通过");
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
            })

            
        }
    }
};
</script>
